import { render } from "./ClientCheckList.vue?vue&type=template&id=fdd61ab6&scoped=true"
import script from "./ClientCheckList.vue?vue&type=script&lang=js"
export * from "./ClientCheckList.vue?vue&type=script&lang=js"

import "./ClientCheckList.vue?vue&type=style&index=0&id=fdd61ab6&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd61ab6"]])

export default __exports__